<template>
  <div>
    <div class="PasswordRetrieval1" v-if="isStep1">
      <div class="login-inner">
        <div class="login-content">
          <div class="login-title">密码找回</div>
          <div class="login-title-line"></div>
          <van-form v-if="isStep1" @submit="onSubmit" ref="loginForm" class="login-form">
            <van-field type="digit" v-model="user.phone" name="手机号" placeholder="请输入11位手机号" maxlength="11" class="iconfont icon-shouji login-field" :rules="[
                { required: true, message: '必填' },
                { pattern: /^\d{11}$/, message: '手机号有误' },
              ]" />
            <van-field v-model="user.identifying_code" type="text" name="验证码" placeholder="请输入验证码" maxlength="6" class="iconfont icon-anquan login-field" :rules="[
                { required: true, message: '必填' },
                { pattern: /^[0-9]{6}$/, message: '验证码有误' },
              ]">
              <template #button>
                <!-- 倒计时 -->
                <van-count-down :time="time" format="ss s" v-if="isCountDownShow" @finish="isCountDownShow = false" />
                <!-- 验证码 -->
                <span v-else @click.prevent="onSendSms" native-type="button" class="send-identifying_code-btn" round size="mini" type="default">
                  获取验证码
                </span>
              </template>
            </van-field>
            <div class="login-handle">
              <van-button class="login-handle-btn" round block type="info" native-type="submit"><span>提</span><span>交</span></van-button>
            </div>
            <div class="fanhui login-handle">
              <van-button class="login-handle-btn opposite" round block type="default" @click="goBackAccountLogin"><span>返</span><span>回</span></van-button>
            </div>
          </van-form>
        </div>
      </div>
    </div>
    <div class="PasswordRetrieval2" v-else>
      <div class="login-inner">
        <div class="login-content">
          <div class="login-title">密码找回</div>
          <div class="login-title-line"></div>
          <van-form v-if="!isStep1" @submit="onSubmit1" ref="PasswordForm" class="login-form">
            <div class="showName">账号：{{ username }}</div>
            <van-field v-model="user1.password1" :type="showPassword1" name="密码" placeholder="请输入8位密码，支持英文、数字" maxlength="8" class="iconfont icon-yuechi" :rules="[
                { required: true, message: '必填' },
                { pattern: /^[a-zA-Z0-9]{8}/, message: '格式错误' },
              ]">
              <!-- <template #button><span class="iconfont icon-24gl-eyeHide" @click="xianshieye('1')" :class="xianshi1 && 'liangeye'"></span></template> -->
            </van-field>

            <van-field v-model="user1.password2" :type="showPassword2" name="密码" placeholder="请再次输入密码" maxlength="8" class="iconfont icon-yuechi" :rules="[
                { required: true, message: '必填' },
                { pattern:  /^[a-zA-Z0-9]{8}/, message: '格式错误' },
                { validator: asyncValidator, message: '输入不一致' },
              ]">
              <template #button><span class="iconfont icon-24gl-eyeHide" @click="xianshieye('2')" :class="xianshi2 && 'liangeye'"></span></template>
            </van-field>
            <div class="login-handle">
              <van-button class="login-handle-btn" round block type="info" native-type="submit"><span>提</span><span>交</span></van-button>
            </div>
            <div class="fanhui login-handle">
              <van-button class="login-handle-btn opposite" round block type="default" @click="goBackStep1"><span>返</span><span>回</span></van-button>
            </div>
          </van-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { encrypt } from '@/utils/security'

export default {
  name: 'PasswordRetrieval',
  props: {},
  data () {
    return {
      showPassword1: 'password',
      showPassword2: 'password',
      xianshi1: false,
      xianshi2: false,
      username: '',
      token: '',
      user: {
        phone: '',
        identifying_code: ''
      },
      user1: {
        password1: '',
        password2: ''
      },
      isCountDownShow: false,
      time: 60 * 1000,
      isStep1: true,
      goBack: false
    }
  },
  created () { },
  methods: {
    xianshieye (num) {
      this['xianshi' + num] = !this['xianshi' + num]
      if (this['xianshi' + num] === true) {
        this['showPassword' + num] = 'type'
      } else {
        this['showPassword' + num] = 'password'
      }
    },
    // 验证码点击注册
    async onSendSms () {
      try {
        await this.$refs.loginForm.validate('手机号')
      } catch (err) {
        return console.log('验证失败', err)
      }
      // 验证通过显示倒计时
      this.isCountDownShow = true
      // 请求发送验证码
      try {
        // 请求接口
        await this.$Api.sendCode({
          phone: encrypt(this.user.phone)
        })
        this.$toast('发送成功')
      } catch (err) {
        this.isCountDownShow = false
        console.log(err)
      }
    },
    async onSubmit () {
      const flag = this.goBack
      this.goBack = false
      if (flag) return false
      // 1.验证表单
      try {
        await this.$refs.loginForm.validate()
      } catch (error) {
        return console.log('验证失败', error)
      }
      try {
        // 2.请求接口验证手机和验证码
        const res = await this.$Api.retrievePwdVerify({
          phone: encrypt(this.user.phone),
          code: encrypt(this.user.identifying_code)
        })
        this.token = res.token
        this.username = res.username
        setTimeout(() => {
          this.isStep1 = false
        }, 100)
      } catch (error) {
        // console.log(error)
      }
    },
    async onSubmit1 () {
      //
      try {
        await this.$Api.retrievePwdReset({
          token: this.token,
          password: encrypt(this.user1.password2),
          username: this.username,
          phone: encrypt(this.user.phone)
        })
        // 提示修改成功
        this.$toast('修改成功')
        // 成功修改密码后到账号密码登录页面
        this.$emit('goBackAccountLogin', 'AccountLogin')
      } catch (error) {
        console.log(error)
      }
    },
    asyncValidator () {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(this.user1.password1 == this.user1.password2)
        }, 0)
      })
    },
    goBackAccountLogin () {
      this.$emit('goBackAccountLogin', 'AccountLogin')
    },
    goBackStep1 () {
      this.goBack = true
      this.isStep1 = true
    }
  },
  computed: {},
  watch: {},
  components: {}
}
</script>

<style lang="scss" scoped>
.login-inner {
  box-shadow: 0 1.06vw 4.1vw 0 rgb(0 0 0 / 15%);
  border-radius: 8px;
  background: #fafafa;
}
.login-item {
  margin-bottom: 6.019vw;
  position: relative;
  .msg-tips {
    color: red;
    font-size: 2.778vw;
    position: absolute;
    left: 0;
    width: 100%;
    bottom: -4.167vw;
  }
  .borders {
    border-bottom: 1px solid #000;
  }
  input {
    width: 60%;
    font-size: 2.778vw;
    appearance: none;
    outline: none;
    box-sizing: border-box;
    border: none;
    border-radius: 0;
    margin-bottom: 1.778vw;
    padding: 1vw 0;
  }
  a {
    font-size: 2.778vw;
    text-decoration: none;
    color: #013995;
  }
}
.notice {
  color: #757575;
  font-size: 2.963vw;
  text-align: center;
  line-height: 1.4;
  margin-top: 8.148vw;
  a {
    text-decoration: none;
    color: #013995;
  }
}
.login-btn {
  display: flex;
  justify-content: center;
  Button {
    font-size: 3.889vw;
    color: #fff;
    font-weight: bold;
    appearance: none;
    outline: none;
    border: none;
    height: 8.796vw;
    width: 70%;
    border-radius: 4.444vw;
    margin-top: 2vw;
    background: linear-gradient(139deg, #2e76f3, #3f55c2);
    &.disabled {
      background: linear-gradient(139deg, #a7a7a7, #c5c5c5);
    }
  }
}
.login-btns {
  display: flex;
  justify-content: center;
  Button {
    font-size: 3.889vw;
    color: rgb(0, 0, 0);
    font-weight: bold;
    appearance: none;
    outline: none;
    border: none;
    height: 8.796vw;
    width: 70%;
    border-radius: 4.444vw;
    margin-top: 2vw;
    &.disabled {
      background: linear-gradient(139deg, #a7a7a7, #c5c5c5);
    }
  }
}
.login-nc {
  float: right;
  margin-bottom: 5.926vw;
  font-size: 2.963vw;
}
.bottomLine {
  border: 0.0125rem solid black;
}
.send-identifying_code-btn {
  color: #2e76f3;
}

.login-content {
  position: relative;
  background-color: #fff;
  padding: 8.333vw 2.63vw 5.556vw;
  text-align: center;
}
.login-title {
  width: 100%;
  text-align: center;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #333333;
  font-size: 5.3333vw;
  height: 6.9vw;
}
.login-inner {
  background-color: #ffffff;
  border-radius: 0.926vw;
  padding: 0 7.13vw;
  .login-inner-title {
    font-size: 4.074vw;
    color: #333330;
    line-height: 1.4;
    padding: 4.63vw 0 1.852vw;
    text-align: center;
    border-bottom: 0.278vw solid #006df1;
    margin-bottom: 3.241vw;
  }
  .login-nav {
    background-color: #d3e6ff;
    height: 8.704vw;
    border-radius: 0.278vw;
    display: flex;
    span {
      font-size: 3.426vw;
      font-weight: bold;
      color: #006df1;
      flex: 1;
      height: 100%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      &.active {
        color: #fff;
        background-color: #006df1;
      }
    }
  }
  .empty-wrapper {
    height: 73.889vw;
    .empty-inner {
      span {
        margin-top: 13.889vw;
        font-size: 0;
        width: 52.963vw;
        height: 10.741vw;
        line-height: 10.741vw;
        background-color: #f5faff;
        &::before {
          content: "敬请期待";
          font-size: 4.074vw;
          color: #80b9ff;
          font-weight: bold;
        }
      }
    }
  }
}
.login-form {
  margin: 13.333vw 0 8vw 0;
  .van-field {
    margin-bottom: 10.6vw;
    overflow: visible;
    position: relative;
    ::v-deep .van-cell__value {
      position: initial;
    }
    ::v-deep .van-field__error-message {
      position: absolute;
      left: 16px;
      bottom: -5vw;
    }
    ::v-deep .van-field__button {
      height: 24px;
    }
  }
}
.login-title-line {
  display: inline-block;
  width: 7vw;
  border-bottom: 1vw solid #0852c8;
}
.login-handle {
  height: 10.6667vw;
  display: flex;
  justify-content: center;
  margin-top: 4vw;
  .login-handle-btn {
    height: 10.6667vw;
    font-weight: bold;
    color: #ffffff;
    font-size: 4.26vw;
    line-height: 10.6667vw;
    background: #002fa7;
    span {
      margin: 0 6px;
    }
  }
  .opposite {
    background: #ffffff;
    border: 2px solid #002fa7;
    color: #002fa7;
  }
}
.showName {
  font-size: 3.7vw;
  color: #333333;
  text-align: left;
  margin: 0 16px 3.7vw 16px;
}
</style>
